import { useEffect } from "react";
import { GeoCalculationsByIdsServiceParams, LoadSlotChangesServiceParams } from "../api/api-packages";
import { UrlParams } from "../url/redux";
import { validate } from "../core/plugins/pluginValidator";
import { plugins } from "../core/plugins/plugins";
import { initAxiosInstance, SystemConfig } from "../api/axiosInstance";
import { getPluginsConfiguration } from "../common/mapstore/pluginsConfiguration";
import Logger from "../common/util/Logger";
import { default as Axios } from "axios";
import { getBaseUrl } from "../common/util/baseUrlUtil";

const logger = new Logger("Startup");

export interface StartupDispatchProps {
    featureToLayersMapping: () => Promise<void>;
    changeTypeColorMapping: () => Promise<void>;
    loadGeoCalculationsByIds: (params: GeoCalculationsByIdsServiceParams) => Promise<void>;
    loadSlotChanges: (params: LoadSlotChangesServiceParams) => Promise<void>;
    loginToWS: () => Promise<void>;
    getCapabilities: () => Promise<void>;
    showError: (title: string, message: string) => void;
    setAxiosInitialized: (initialized: boolean) => void;
    setWizardPortalUrl: (url: string) => void;
}

export interface StartupStateProps {
    ticket?: string;
    config?: unknown;
    urlParams?: UrlParams;
    axiosInitialized: boolean;
}

export const Startup = (props: StartupStateProps & StartupDispatchProps) => {
    const {
        ticket,
        axiosInitialized,
        featureToLayersMapping,
        getCapabilities,
        showError,
        setAxiosInitialized,
        setWizardPortalUrl,
    } = props;

    useEffect(() => {
        const initWizardPortalUrl = async () => {
            const { data: systemConfig } = await Axios.get<SystemConfig>(`${getBaseUrl()}/configs/systemConfig.json`);
            setWizardPortalUrl(systemConfig.wizardPortalUrl);
        };

        initWizardPortalUrl();
    }, []);
    useEffect(() => {
        const initAxios = async () => {
            await initAxiosInstance();
            setAxiosInitialized(true);
        };
        initAxios();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (ticket && axiosInitialized) {
            featureToLayersMapping();
            getCapabilities();
            //validate();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ticket, axiosInitialized]);

    useEffect(() => {
        const checkPlugins = async () => {
            const pluginsConfiguration = await getPluginsConfiguration();
            const result = validate(plugins, pluginsConfiguration.plugins);
            if (pluginsConfiguration.validatePlugins && result.length > 0) {
                logger.error(`${result.join()} not registered properly. Did you update localConfig.json?`);
                showError("Some plugins are missing", "Check console for more information.");
            }
        };
        checkPlugins();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};
